import React, { useState } from 'react';
import Modal from 'react-modal';
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faClose, faDownload, faExpand } from "@fortawesome/free-solid-svg-icons";
import Tippy from "@tippyjs/react";
import {formatImageTitle} from "../../redux/utility/jwtUtils";


const CurriculumOtherContent = (props) => {
    const [isModalOpen, setIsModalOpen] = useState(false);
    const [modalContent, setModalContent] = useState(null);

    const openModal = (content) => {
        setModalContent(content);
        setIsModalOpen(true);
    };

    const closeModal = () => {
        setIsModalOpen(false);
        setModalContent(null);
    };

    const downloadImage = async (url, filename) => {
        try {
            const response = await fetch(url, {
                useCORS: true,
                method: 'GET',
                headers: {
                    'Content-Type': 'application/octet-stream',
                },
            });

            if (!response.ok) {
                console.error(`Failed to fetch image. Status: ${response.status}`);
                throw new Error(`Failed to fetch image. Status: ${response.status}`);
            }

            const blob = await response.blob();
            const objectUrl = window.URL.createObjectURL(blob);

            const link = document.createElement('a');
            link.href = objectUrl;
            link.download = filename || 'downloaded-image';
            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);
            window.URL.revokeObjectURL(objectUrl);
        } catch (error) {
            console.error('Error during download:', error.message);
        }
    };


    const getCurriculumContent = (val) => {
        switch (val?.type) {
            case 'image':
                return (
                    <>
                                <div key={props.index}>
                                    <div className="content-controls flex justify-end">
                                        <Tippy content='Download Image'>
                                            <button
                                                onClick={() => downloadImage(val.url, val.name)}
                                            >
                                                <FontAwesomeIcon
                                                    className="text-xl text-gray hover:text-primary dark:text-gray-400 mr-5"
                                                    icon={faDownload}
                                                />
                                            </button>
                                        </Tippy>
                                        <Tippy content='Full Screen'>
                                            <a href={val.url} download={val.name}>
                                                <FontAwesomeIcon className="text-xl text-gray hover:text-primary dark:text-gray-400" icon={faExpand} />
                                            </a>
                                        </Tippy>
                                    </div>
                                    <img src={val.url} loading="lazy"
                                         alt={formatImageTitle(val.name)+'- Explore STEMCity | Educational Kit | Robotics | STEM Learning | DIY Project'}
                                         title={val.name+'- Explore STEMCity | Educational Kit | Robotics | STEM Learning | DIY Project'}
                                    />
                                </div>
                    </>
                );
            case 'video':
                return (
                    <>
                        <video width="560" height="315" controls>
                            <source src={val.url} type="video/mp4" />
                            Your browser does not support the video tag.
                        </video>
                        <div className="content-controls">
                            <button onClick={() => openModal(
                                <video width="100%" height="auto" controls>
                                    <source src={val.url} type="video/mp4" />
                                    Your browser does not support the video tag.
                                </video>
                            )}>
                                Full Screen
                            </button>
                            <a href={val.url} download={val.name}>Download</a>
                        </div>
                    </>
                );
            case 'youtube':
                return (
                    <div className="video-wrapper">
                        <iframe
                            width="560"
                            height="315"
                            src={val.url}
                            title={val.name}
                            frameBorder="0"
                            allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                            allowFullScreen
                        />
                    </div>
                );
            case 'file':
                // Preview for PDFs, link for other files
                if (val.url.endsWith('.pdf')) {
                    return (
                        <div className="file-preview">
                            <iframe
                                src={val.url}
                                width="100%"
                                height="500px"
                                title={val.name}
                                style={{ border: 'none' }}
                            />
                        </div>
                    );
                } else {
                    return (
                        <div className="file-content">
                            <a href={val.url} target="_blank" rel="noopener noreferrer">
                                Download {val.name}
                            </a>
                        </div>
                    );
                }
            default:
                return <p>Unsupported content type</p>;
        }
    };

    return (
        <>
            {getCurriculumContent(props.content)}

            <Modal
                isOpen={isModalOpen}
                onRequestClose={closeModal}
                contentLabel="Full Screen Modal"
                style={{
                    content: {
                        top: '50%',
                        left: '50%',
                        right: 'auto',
                        bottom: 'auto',
                        marginRight: '-50%',
                        marginTop: '60px',
                        transform: 'translate(-50%, -50%)',
                        width: '80%',
                        height: '90%',
                    },
                }}
            >
                <div className='flex justify-end'>
                    <Tippy content='Close'>
                        <button onClick={closeModal}>
                            <FontAwesomeIcon className="text-xl text-gray hover:text-primary dark:text-gray-400" icon={faClose} />
                        </button>
                    </Tippy>
                </div>
                <div>{modalContent}</div>
            </Modal>
        </>
    );
};

export default CurriculumOtherContent;
